<template>
  <div class="video-control">
    <div
      class="video-play-btn"
      @click="play()"
    >
      <iconfont
        style="font-size:16px;"
        :name="playing ? '#icon11-12bofanganniu' : '#icon11-11zantingbofanganniu'"
      ></iconfont>
    </div>
    <div class="video-time-content">
      <div class="now-time">
        {{ nowTime | formatTime }}
      </div>
      <span>/</span>
      <div class="total-time">
        {{ duration | formatTime }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoControl',
  props: ['duration', 'nowTime', 'playing'], // eslint-disable-line
  data() {
    return {};
  },
  methods: {
    play() {
      this.$emit('play');
    }
  }
};
</script>
<style lang="scss" scoped>
.video-control {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 150px;
  user-select: none;
}
.video-play-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(124, 124, 124, 0.13);
  border-radius: 50%;
  margin-right: 18px;
  color: #2f58fe;
  cursor: pointer;
}
.video-time-content {
  display: flex;

  > div,
  span {
    line-height: 30px;
  }
}
@media (max-width: 1600px) {
  .video-control {
    width: 120px;
  }
  .video-play-btn {
    width: 36px;
    height: 36px;
    margin-right: 10px;

    > svg {
      transform-origin: center;
      transform: scale(0.8);
    }
  }
  .video-time-content {
    font-size: 12px;
    > div,
    span {
      line-height: 20px;
    }
  }
}
</style>
